import { NJButton, NJHeading, NJText } from '@engie-group/fluid-design-system-react';
import { energyLabel } from './data';
import { planStatus } from './domain';
import type { DevelopmentPlan, Scenario } from './types';

export function Navigation({ scenarios, plans, scenarioId, planId, select, addScenario, addPlan }: {
  scenarios: Scenario[]; plans: DevelopmentPlan[]; scenarioId: string; planId: string | null;
  select: (scenario: string, plan?: string) => void; addScenario: () => void; addPlan: (id: string) => void;
}) {
  return <aside className="sp-navigation" aria-label="Scénarios et plans">
    <NJText as="div" className="pu-label">Projet / Étude</NJText>
    <NJHeading as="h2" scale="sm">Scénarios et plans</NJHeading>
    <NJText scale="sm">Un jeu d’hypothèses, plusieurs plans indépendants.</NJText>
    <NJButton label="Nouveau scénario" icon="add" emphasis="subtle" scale="sm" onClick={addScenario} />
    <ul className="sp-list sp-tree">{scenarios.map(s => <li key={s.id}>
      <div className={`sp-tree-item ${s.id === scenarioId && !planId ? 'is-active' : ''}`}>
        <NJButton label={s.name} icon="tune" scale="sm" emphasis="minimal" onClick={() => select(s.id)} />
        <NJText as="div" scale="sm">Hypothèses · {plans.filter(p => p.scenarioId === s.id).length} plans</NJText>
      </div>
      <ul className="sp-list sp-plans">{plans.filter(p => p.scenarioId === s.id).map(p =>
        <li key={p.id} className={`sp-tree-item ${planId === p.id ? 'is-active' : ''}`}>
          <NJButton label={p.name} icon="route" scale="sm" emphasis="minimal" onClick={() => select(s.id, p.id)} />
          <NJText as="div" scale="sm">{energyLabel(p.energy)} · {planStatus(p)}</NJText>
        </li>)}</ul>
      <NJButton label="Ajouter un plan" aria-label={`Ajouter un plan · ${s.name}`} icon="add" scale="sm" emphasis="minimal" onClick={() => addPlan(s.id)} />
    </li>)}</ul>
  </aside>;
}
